import React from 'react';
import { getDisplayName } from 'helpers/component';
import { MixpanelAnalytics } from 'tracking/mixpanelBeconTarget';

export default function TrackedComponentEnhancer({ trackedName, targetComponent: TargetComponent, sendToMixPanel }) {
    class TrackedComponent extends React.Component {
        render() {
            const { onClick, className = '', payload = {} } = this.props || {};
            const componentProps = {
                ...this.props,
                onClick: (event) => {
                    if (onClick) { onClick(event); }
                    // additional logic
                    if (sendToMixPanel) {
                        MixpanelAnalytics([{
                            hitType: 'event',
                            eventAction: trackedName,
                            ...payload
                        }]);
                    }
                }
            };
            if (trackedName) {
                componentProps.className = className ? `${className} ${trackedName}` : trackedName;
            }
            return <TargetComponent {...componentProps} />;
        }
    }
    TrackedComponent.displayName = `TrackedComponent(${getDisplayName(TargetComponent)})`;
    return TrackedComponent;
}



// WEBPACK FOOTER //
// ./src/hoc/TrackedComponent.js